module.exports = __webpack_public_path__ + "static/media/rotasFavoritasDisabled.8a2d5e25.svg";